import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

import { AppState } from 'services/types';
import {
    requestLoadSpraySubmissions,
    canceledLoadSpraySubmissions
} from 'services/spraySubmissions/actions';
import { selectLoadSpraySubmissionsParams } from 'services/spraySubmissions/params';

interface ConnectedProps {
    params?: ReturnType<typeof selectLoadSpraySubmissionsParams>;
}

interface DispatchProps {
    requestLoadSpraySubmissions: typeof requestLoadSpraySubmissions;
    canceledLoadSpraySubmissions: typeof canceledLoadSpraySubmissions;
}

type Props = ConnectedProps & DispatchProps;

export class SubmissionsRequestComponent extends React.PureComponent<Props> {
    componentDidMount(): void {
        const { props } = this;
        props.requestLoadSpraySubmissions();
    }

    componentDidUpdate(prevProps: Props): void {
        const { props } = this;
        if (!isEqual(prevProps.params, props.params)) {
            props.requestLoadSpraySubmissions();
        }
    }

    componentWillUnmount(): void {
        const { props } = this;
        props.canceledLoadSpraySubmissions();
    }

    render(): null {
        return null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    params: selectLoadSpraySubmissionsParams
});

export default connect(mapStateToProps, {
    requestLoadSpraySubmissions,
    canceledLoadSpraySubmissions
})(SubmissionsRequestComponent);
